export default function RemoveIcon({ onClick, stroke }) {
    const handleClick = (e) => {
        e.stopPropagation();
        onClick(e);
    };

    return (
        <svg 
            onClick={handleClick} 
            width="8" 
            height="8" 
            viewBox="0 0 8 8" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_3355_37178)">
                <path 
                    d="M7 1L1 7M1 1L7 7L1 1Z" 
                    stroke={stroke}  
                    strokeWidth="1.5" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                />
            </g>

            <defs>
                <clipPath id="clip0_3355_37178">
                    <rect 
                        width="8" 
                        height="8" 
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
